import React from "react";
import Select from "react-select";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  Table,
  Modal,
} from "react-bootstrap";
import ReactDatetime from "react-datetime";
import { useDispatch, useSelector } from "react-redux";
import {
  ComposedChart,
  Bar,
  LabelList,
  YAxis,
  XAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
} from "recharts";
import { getKpiPatroli, getAllCabang, getCabangAktif, getRekapPatrol } from "../../../stores";
import { useHistory } from "react-router-dom";

import moment from "moment";
import { array } from "prop-types";
import { CardBody, CardHeader } from "reactstrap";

function Panels() {
  const dispatch = useDispatch();
  const history = useHistory();
  const monitoring = useSelector((state) => state.monitoringReducer);
  const cabang = useSelector((state) => state.cabangReducer);
  const auth = useSelector((state) => state.authReducer);

  const date = new Date();
  const [dariTgl, setDariTgl] = React.useState(new Date().setHours(0, 0, 0, 0));
  const [smpTgl, setSmpTgl] = React.useState(new Date().setHours(23, 59, 0, 0));
  const [kpiOption, setKpiOption] = React.useState(null);
  const [idCabang, setIdCabang] = React.useState([]);
  const [listRuang, setListRuang] = React.useState([]);
  const [showDetailModal, setShowDetailModal] = React.useState(false);
  const [selectedRekapDetail, setSelectedRekapDetail] = React.useState(null);

  const rekapPatrolData = monitoring.getRekapPatrol || {};
  const rekapList = rekapPatrolData.detail || [];

  // Extract active shifts names dynamically
  const activeShifts = React.useMemo(() => {
    const shiftSet = new Set();
    
    // 1. Ambil shift dari data kpiPatroli jika ada
    if (monitoring.kpiPatroli && Array.isArray(monitoring.kpiPatroli.data)) {
      monitoring.kpiPatroli.data.forEach(s => {
        if (s.namaShift) shiftSet.add(s.namaShift);
      });
    }
    
    // 2. Ambil shift dari rekapList sebagai fallback/tambahan
    if (Array.isArray(rekapList)) {
      rekapList.forEach(day => {
        if (Array.isArray(day.list)) {
          day.list.forEach(shift => {
            if (shift.namaShift) shiftSet.add(shift.namaShift);
          });
        }
      });
    }
    
    return Array.from(shiftSet).sort();
  }, [monitoring.kpiPatroli, rekapList]);

  const getBadgeVariant = (status) => {
    if (!status) return "secondary";
    const s = status.toLowerCase();
    if (s === "below") return "danger";
    if (s === "meet") return "warning";
    return "success";
  };
  // {
  //   value: "",
  //   label: "Choose the Client",
  //   isDisabled: true,
  // }
  const [listCabang, setListCabang] = React.useState([]);
  React.useEffect(() => {
    if (monitoring.kpiPatroli) {
      setKpiOption(monitoring.kpiPatroli.data);
      setListRuang(monitoring.kpiPatroli.listRuang);
    }
  }, [monitoring.kpiPatroli]);

  React.useEffect(() => {
    getAllCabang(dispatch);
    getCabangAktif(dispatch);
  }, []);
  React.useEffect(() => {
    getRekapPatrol(dispatch, {
      dariTgl: dariTgl,
      smpTgl: smpTgl,
      idCabangWeb: idCabang.value,
    });
  }, [dariTgl, smpTgl, idCabang]);

  React.useEffect(() => {
    getKpiPatroli(dispatch, {
      dariTgl: dariTgl,
      smpTgl: smpTgl,
      idCabangWeb: idCabang.value,
    });
  }, [dariTgl, smpTgl, idCabang]);

  React.useEffect(() => {
    let tmp = cabang.getCabangAktif.map((val, index) => {
      return {
        // ...val,
        label: `${val.namaCabang} - ${val.namaClient}`,
        value: val.idCabang,
      };
    });

    setListCabang(tmp);
    tmp.map((val, index) => {
      if (index === 0) {
        setIdCabang(val);
      }
    });
  }, [cabang.getCabangAktif]);

  return (
    <>
      <Container fluid>
        <Row className="mb-3">
          <Col md="3">
            <h4 className="title">Start Date</h4>
            <Form.Group>
              <ReactDatetime
                inputProps={{
                  className: "form-control",
                  placeholder: "Date Picker Here",
                }}
                onChange={(e) => {
                  setDariTgl(e.toDate().setHours(0, 0, 0, 0));
                }}
                value={dariTgl}
                initialValue={dariTgl}
                timeFormat={false}
              ></ReactDatetime>
            </Form.Group>
          </Col>
          <Col md="3">
            <h4 className="title">End Date</h4>
            <Form.Group>
              <ReactDatetime
                inputProps={{
                  className: "form-control",
                  placeholder: "Date Picker Here",
                }}
                onChange={(e) => {
                  setSmpTgl(e.toDate().setHours(23, 59, 0, 0));
                }}
                value={smpTgl}
                initialValue={smpTgl}
                timeFormat={false}
              ></ReactDatetime>
            </Form.Group>
          </Col>
        </Row>

        {monitoring.kpiPatroli && (
          <>
            <Row>
              <Col md="12">
                <Card>
                  <Card.Header>
                    <Row>
                      <Col md="6">
                        <Card.Title as="h4">
                          Report Patroli Achievement
                        </Card.Title>
                      </Col>

                      {auth.role === "all" ||
                        auth.role === "gsc" ||
                        auth.role === "market" ? (
                        <>
                          <Col md="6">
                            <Select
                              className="react-select primary pb-2"
                              classNamePrefix="react-select"
                              name="singleSelect"
                              onChange={(value) => {
                                setIdCabang(value);
                              }}
                              value={idCabang}
                              options={[
                                // {
                                //   value: "",
                                //   label: "Choose the Client",
                                //   isDisabled: true,
                                // },
                                ...listCabang,
                              ]}
                              placeholder="Single Select"
                            />
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                    </Row>
                  </Card.Header>
                  <Card.Body>
                    <Row className="justify-content-center">
                      <Col
                        md={4}
                        // key={index}
                        className="mb-3 d-flex justify-content-center"
                      >
                        <div
                          className="numbers d-flex flex-column align-items-center p-2"
                          style={{
                            border: "1px solid #ccc", // Garis tepi
                            borderRadius: "8px", // Sudut melengkung
                            width: "100%", // Sesuaikan lebar
                            maxWidth: "200px", // Lebar maksimal
                            padding: "10px", // Padding untuk jarak di dalam kotak
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Bayangan halus
                            textAlign: "center", // Teks di tengah horizontal
                          }}
                        >
                          <Row>
                            <div className="d-flex flex-column align-items-center">
                              <p
                                className="card-category"
                                style={{
                                  fontWeight: "bold",
                                  color: "black",
                                  margin: "0 0 5px 0", // Margin bawah untuk jarak antar teks
                                }}
                              >
                                Status:
                              </p>
                              <Card.Title as="h4" className="m-0"></Card.Title>
                            </div>
                            <div className="d-flex flex-column align-items-center ml-2">
                              <p
                                className="card-category"
                                style={{
                                  fontWeight: "bold",
                                  color:
                                    monitoring.kpiPatroli.nilaiAkhir === "Below"
                                      ? "red"
                                      : monitoring.kpiPatroli.nilaiAkhir ===
                                        "Meet"
                                        ? "orange"
                                        : "green",
                                  margin: 0,
                                }}
                              >
                                {monitoring.kpiPatroli.nilaiAkhir}
                              </p>
                            </div>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      {monitoring.kpiPatroli.data.map((val, index) => {
                        return (
                          <Col
                            md={4}
                            key={index}
                            className="mb-3 d-flex justify-content-center"
                          >
                            <div
                              className="numbers d-flex flex-column align-items-center p-2"
                              style={{
                                border: "1px solid #ccc", // Garis tepi
                                borderRadius: "8px", // Sudut melengkung
                                width: "100%", // Sesuaikan lebar
                                maxWidth: "200px", // Lebar maksimal
                                padding: "10px", // Padding untuk jarak di dalam kotak
                                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Bayangan halus
                                textAlign: "center", // Teks di tengah horizontal
                              }}
                            >
                              <Row>
                                <div className="d-flex flex-column align-items-center">
                                  <p
                                    className="card-category"
                                    style={{
                                      fontWeight: "bold",
                                      color: "black",
                                      margin: "0 0 5px 0", // Margin bawah untuk jarak antar teks
                                    }}
                                  >
                                    {val.namaShift}:
                                  </p>
                                  <Card.Title
                                    as="h4"
                                    className="m-0"
                                  ></Card.Title>
                                </div>
                                <div className="d-flex flex-column align-items-center ml-2">
                                  <p
                                    className="card-category"
                                    style={{
                                      fontWeight: "bold",
                                      color:
                                        val.hasilPatroli === "Below"
                                          ? "red"
                                          : val.hasilPatroli === "Meet"
                                            ? "orange"
                                            : "green",
                                      margin: 0,
                                    }}
                                  >
                                    {val.hasilPatroli}
                                  </p>
                                </div>
                              </Row>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>

                    {/* <Row>
                      <Col>
                        <div className="numbers d-flex justify-content-center">
                          <div className="d-flex flex-column align-items-center">
                            <p className="card-category">Achievement</p>
                            <Card.Title as="h4">
                              {monitoring.kpiPatroli.pencapaian} %
                            </Card.Title>
                          </div>
                          <div className="d-flex flex-column align-items-center ml-3">
                            <p className="card-category">Target</p>
                            <Card.Title as="h4">
                              {monitoring.kpiPatroli.target} %
                            </Card.Title>
                          </div>
                        </div>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col>
                        {kpiOption && (
                          <div style={{ width: "100%", height: 300 }}>
                            <ResponsiveContainer>
                              <ComposedChart data={kpiOption}>
                                <XAxis dataKey="namaShift" />
                                <YAxis />
                                <Tooltip />
                                <Legend verticalAlign="top" height={36} />
                                <CartesianGrid stroke="#f5f5f5" />
                                <Bar
                                  dataKey="Target Patroli"
                                  barSize={20}
                                  fill="#ff8200"
                                  stackId="b"
                                ></Bar>
                                <Bar
                                  dataKey="Using NFC"
                                  barSize={20}
                                  fill="#006605"
                                  stackId="a"
                                ></Bar>
                                <Bar
                                  dataKey="Without NFC"
                                  barSize={20}
                                  fill="#006bf7"
                                  stackId="a"
                                ></Bar>
                              </ComposedChart>
                            </ResponsiveContainer>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer>
                    <hr></hr>
                    <Row>
                      <Col className="d-flex justify-content-end">
                        <Button
                          onClick={() => {
                            history.push("/admin/reportPatroli");
                          }}
                          className="btn-wd btn-outline mr-1"
                          type="button"
                          variant={
                            monitoring.kpiPatroli.pencapaian <
                              monitoring.kpiPatroli.target
                              ? "danger"
                              : "info"
                          }
                        >
                          Detail
                        </Button>
                      </Col>
                    </Row>
                  </Card.Footer>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Card>
                  <CardHeader>
                    <h3>Patrol Location</h3>
                  </CardHeader>
                  <CardBody style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <div className="d-flex flex-wrap flex-column">
                      {listRuang.map((val, index) => {
                        return (
                          <div
                            style={{
                              borderWidth: 2,
                              width: "100%",
                              marginTop: 0,
                              // backgroundColor: "red",
                            }}
                          >
                            <Row key={index}>
                              <Col sm="1">
                                <label
                                  style={{
                                    textTransform: "none",
                                    fontSize: 14,
                                    color: "black",
                                    fontWeight: "bold",
                                    color: "black",
                                  }}
                                >
                                  {index + 1}
                                </label>
                              </Col>
                              <Col sm="0">
                                <label
                                  style={{
                                    textTransform: "none",
                                    fontSize: 14,
                                    color: "black",

                                    color: "black",
                                  }}
                                >
                                  :
                                </label>
                              </Col>
                              <Col sm="9">
                                <label
                                  style={{
                                    textTransform: "none",
                                    fontSize: 14,
                                    color: "black",

                                    color: "black",
                                  }}
                                >
                                  {val.area}
                                </label>
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="6">
                <Card>
                  <CardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="m-0">Rekap Patroli</h3>
                    {rekapPatrolData.lastSync && (
                      <span style={{ fontSize: "11px", color: "#666", fontWeight: "normal" }}>
                        Terakhir Sinkron: {rekapPatrolData.lastSync}
                      </span>
                    )}
                  </CardHeader>
                  <CardBody style={{ maxHeight: "300px", overflow: "auto", padding: 0 }}>
                    <Table striped bordered hover responsive style={{ minWidth: "800px", margin: 0 }}>
                      <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
                        <tr>
                          <th>No</th>
                          <th>Tanggal</th>
                          {activeShifts.map((shiftName, idx) => (
                            <th key={idx}>{shiftName}</th>
                          ))}
                          <th>Status Akhir</th>
                          <th>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rekapList.length === 0 ? (
                          <tr>
                            <td colSpan={4 + activeShifts.length} className="text-center">
                              Tidak ada data rekap patroli
                            </td>
                          </tr>
                        ) : (
                          rekapList.map((val, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{moment(val.tanggalLaporan).format("DD MMM YYYY")}</td>
                                {activeShifts.map((shiftName, idx) => {
                                  const shiftRecord = val.list.find((item) => item.namaShift === shiftName);
                                  return (
                                    <td key={idx}>
                                      {shiftRecord ? (
                                        <Badge variant={getBadgeVariant(shiftRecord.hasilPatroli)}>
                                          {shiftRecord.hasilPatroli} ({shiftRecord.dataPatroli}/{shiftRecord.targetPatroli})
                                        </Badge>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                  );
                                })}
                                <td>
                                  <Badge variant={getBadgeVariant(val.achievement)}>
                                    {val.achievement}
                                  </Badge>
                                </td>
                                <td>
                                  <Button
                                    size="sm"
                                    variant="info"
                                    onClick={() => {
                                      setSelectedRekapDetail(val);
                                      setShowDetailModal(true);
                                    }}
                                  >
                                    Detail
                                  </Button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* Shift Detail Modal */}
            <Modal
              show={showDetailModal}
              onHide={() => {
                setShowDetailModal(false);
                setSelectedRekapDetail(null);
              }}
              size="lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Detail Rekap Patroli - {selectedRekapDetail && moment(selectedRekapDetail.tanggalLaporan).format("DD MMM YYYY")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedRekapDetail ? (
                  <>
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                      <div>
                        <h5>Ringkasan Harian</h5>
                        <div>Total Target: <strong>{selectedRekapDetail.totalTarget}</strong></div>
                        <div>Total Patroli: <strong>{selectedRekapDetail.totalPatrol}</strong></div>
                      </div>
                      <div className="text-right">
                        <h5>Status Akhir</h5>
                        <Badge 
                          variant={getBadgeVariant(selectedRekapDetail.achievement)} 
                          style={{ fontSize: "16px", padding: "8px 16px" }}
                        >
                          {selectedRekapDetail.achievement}
                        </Badge>
                      </div>
                    </div>

                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Nama Shift</th>
                          <th>Target Patroli</th>
                          <th>Data Patroli</th>
                          <th>Menggunakan NFC</th>
                          <th>Tanpa NFC</th>
                          <th>Status Akhir</th>
                          <th>Ruangan Tidak Dikunjungi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRekapDetail.list.map((shift, idx) => (
                          <tr key={idx}>
                            <td>{shift.namaShift}</td>
                            <td>{shift.targetPatroli}</td>
                            <td>{shift.dataPatroli}</td>
                            <td>{shift.usingNFC}</td>
                            <td>{shift.withoutNFC}</td>
                            <td>
                              <Badge variant={getBadgeVariant(shift.hasilPatroli)}>
                                {shift.hasilPatroli}
                              </Badge>
                            </td>
                            <td>
                              {shift.ruanganTidakDikunjungi && shift.ruanganTidakDikunjungi.length > 0 ? (
                                <ul className="pl-3 mb-0" style={{ fontSize: "12px" }}>
                                  {shift.ruanganTidakDikunjungi.map((room, rIdx) => (
                                    <li key={rIdx}>{room.namaRuangan || room}</li>
                                  ))}
                                </ul>
                              ) : (
                                <span className="text-success font-weight-bold">Semua Dikunjungi</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </>
                ) : (
                  <p>Memuat detail...</p>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
                  Tutup
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Container>
    </>
  );
}

export default Panels;
